module.exports = __webpack_public_path__ + "static/media/arrowLeftPurple.24474cc8.svg";